import { render, staticRenderFns } from "./ProjectServiceLineItems.vue?vue&type=template&id=4e98541f&scoped=true"
import script from "./ProjectServiceLineItems.vue?vue&type=script&lang=js"
export * from "./ProjectServiceLineItems.vue?vue&type=script&lang=js"
import style0 from "./ProjectServiceLineItems.vue?vue&type=style&index=0&id=4e98541f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e98541f",
  null
  
)

export default component.exports